(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-directory"]) return;
  try {
    
  function setupContactDirectory() {
    document.querySelectorAll('.contact-directory__contents').forEach((contents) => {
      if (contents.dataset.ready) return;
      contents.dataset.ready = 'true';
      contents.open = !window.matchMedia('(max-width: 899px)').matches;
      contents.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 899px)').matches) contents.open = false;
      }));
    });
  }
  setupContactDirectory();
  document.addEventListener('shopify:section:load', setupContactDirectory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
